import { render, staticRenderFns } from "./workBranchItem.vue?vue&type=template&id=09788526&scoped=true&"
import script from "./workBranchItem.vue?vue&type=script&lang=js&"
export * from "./workBranchItem.vue?vue&type=script&lang=js&"
import style0 from "./workBranchItem.vue?vue&type=style&index=0&id=09788526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09788526",
  null
  
)

export default component.exports